import { ResolutionNodeCard } from "../resolution/ResolutionCard";
import { PaymentCard } from "../payment/PaymentCard";
import { FormCard } from "../form/cards/form-card";
import { SingCard } from "../form/cards/sing-card";
import { ConfirmAssociationCard } from "../form/cards/confirm-association-card";
import type { FormalityRequestType } from "@/types/entities/formality-request";
import type { NodeExecutionType } from "@/types/entities/flows";
import { getRelevantAssignment } from "@/utils/procedures-ui";

interface NodeCardsListProps {
  formalityRequest?: FormalityRequestType;
  nodes?: Array<NodeExecutionType>;
  startIndex?: number;
  procedureId: string;
}

export const NodeCardsList = ({
  formalityRequest,
  nodes,
  startIndex = 0,
  procedureId,
}: NodeCardsListProps) => {
  return nodes?.map((node, index) => {
    const globalIndex = startIndex + index;
    const rawType = (node.node.type || "").toUpperCase();
    const refName = (node.node.ref_name || "").toLowerCase();

    if (rawType === "FORM" || refName === "form-node") {
      // Get the filled_form_id from either user_form_assignments or form_assignments
      const filledFormId =
        node.form_assignments?.[0]?.filled_form_id ??
        getRelevantAssignment(node.user_form_assignments)?.filled_form_id ??
        "";

      return (
        <FormCard
          key={node.id ?? node.node.id ?? globalIndex}
          node={node}
          index={globalIndex}
          procedureId={procedureId}
          formAssignment={filledFormId}
        />
      );
    }

    if (rawType === "SIGN_DOCUMENT" || refName === "sign-document-node") {
      return (
        <SingCard
          key={node.id ?? node.node.id ?? globalIndex}
          node={node}
          index={globalIndex}
          procedureId={procedureId}
        />
      );
    }

    if (rawType === "PAYMENT" || refName === "payment-node") {
      if (node.payment_request) {
        return (
          <PaymentCard
            key={node.id ?? node.node.id ?? globalIndex}
            paymentRequestId={node.payment_request.id}
            nodeExecution={node}
            procedureId={procedureId}
            index={globalIndex}
          />
        );
      }
      return null;
    }

    if (rawType === "RESOLUTION" || refName === "resolution-node") {
      return (
        <ResolutionNodeCard
          key={node.id ?? node.node.id ?? globalIndex}
          node={node}
          index={globalIndex}
          procedureId={procedureId}
          tramite={formalityRequest}
        />
      );
    }

    if (
      rawType === "CONFIRM_ASSOCIATE_USER" ||
      refName === "confirm-associate-user-node"
    ) {
      return (
        <ConfirmAssociationCard
          key={node.id ?? node.node.id ?? globalIndex}
          node={node}
          index={globalIndex}
          procedureId={procedureId}
        />
      );
    }

    return null;
  });
};
